import useTranslation from "next-translate/useTranslation"

import { IProject } from "@api/schema"
import TranslatedHtml from "@components/common/TranslatedHtml"

interface IProps {
  project: IProject
}

const ProjectCreatorText: React.FC<IProps> = ({ project }: IProps) => {
  const { t } = useTranslation("common")

  const user = project.createdBy

  // HTML because the translated date might contain "&#x2F;"" for slashes
  return <TranslatedHtml
    content="project.creatorText" params={{
      date: project.createdAt || '',
      user: user ? user.username : t("user.unknown"),
    }}
  />
}

export default ProjectCreatorText
